/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppCover.vue?vue&type=template&id=7a5b6f8b&"
import script from "./AppCover.vue?vue&type=script&lang=js&"
export * from "./AppCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports